import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { ICaseInfo } from '@pages/articles/interfaces/article.interface';
import { TranslateComponent } from '@translate/components/translate/translate.component';

@Component({
  selector: 'noda-articles-case-info',
  standalone: true,
  templateUrl: './article-case-info.component.html',
  styleUrls: ['./article-case-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateComponent,
  ],
})
export class ArticleCaseInfoComponent {
  public caseInfo: InputSignal<ICaseInfo> = input<ICaseInfo>();
}
